import { cacheExchange, createClient, fetchExchange } from '@urql/core';
import { persistedExchange } from '@urql/exchange-persisted';

import { contentfulRetryExchange } from '@src/lib/graphql/contentful-retry-exchange';
import { logWarning } from '@utils/miscUtils';

const urqlPersistedExchange = persistedExchange({
	preferGetForPersistedQueries: true,
	enforcePersistedQueries: false,
});

const urqlExchanges = [cacheExchange, contentfulRetryExchange, urqlPersistedExchange, fetchExchange];

export const getGraphQLClientForContentful = (url: string, preview = false): ReturnType<typeof createClient> => {
	const accessToken: string = preview
		? process.env.TAG_CONTENTFUL_PREVIEW_ACCESS_TOKEN ?? process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN ?? ''
		: process.env.TAG_CONTENTFUL_ACCESS_TOKEN ?? process.env.CONTENTFUL_ACCESS_TOKEN ?? '';

	if (!accessToken) {
		logWarning('Error fetching blogs list by brand - No access token');
	}

	const headersForContentfulGraphQl = {
		Authorization: `Bearer ${accessToken}`,
		'content-type': 'application/json',
	};

	const graphQlClient = createClient({
		url,
		exchanges: urqlExchanges,
		requestPolicy: 'network-only',
		fetchOptions: () => {
			return {
				headers: headersForContentfulGraphQl,
			};
		},
	});
	return graphQlClient;
};
